import { AppThunk } from "../../../../store";
import { makeTypedSetter } from "../makeTypedSetter";
import { setEditedDataInRedux } from "../reportSlice";

export const setEksempelValue = makeTypedSetter<IEksempelrapport, 101>(101);

import { openapi } from "../../../../../openapi";
import { setEditedValueInRedux } from "../reportSlice"; // där du har setEditedValueInRedux
import { setShowFailedMessageThunk, setShowSuccessMessageThunk } from "../../../../global/globalSlice";
import { IEksempelrapport } from "@mcapps/shared/reportSchemas/eksempelRapportSchema";
import { toggleChapterInTree } from "../../../../components/ReportChapterTree/reportChaptersTreeUtils";
import { applyAllRules } from "./eksempelRapportUtils";

export const EKSEMPEL_RAPPORT_ID = 101;

export const fetchProjectDataAndHydrateEksempelGenerellInfoThunk = (): AppThunk => async (dispatch, getState) => {
  const project = getState().adminReducer.project;

  try {
    const mcProject = await dispatch(
      openapi.endpoints.getMcProject.initiate({ projectId: project._id }),
    ).unwrap();
    if (!mcProject) {
      dispatch(setShowFailedMessageThunk("Ingen prosjektdata funnet"));
      return;
    }

    dispatch(setShowSuccessMessageThunk("Hentet prosjektdata"));
    dispatch(
      setEditedValueInRedux({
        code: EKSEMPEL_RAPPORT_ID,
        path: "generellInfo.oppdragsnavn",
        value: mcProject.name,
      }),
    );
  } catch (error) {
    dispatch(setShowFailedMessageThunk("Kunne ikke hente prosjektdata"));
    throw error;
  }
};

export const thunkEksempelKapittelToggled =
  (chapterId: string, next: boolean): AppThunk =>
  (dispatch, getState) => {
    const edited = getState().reportReducer.editedData[101] as IEksempelrapport | null;
    if (!edited) return;

    // 1) user toggle
    const toggled = toggleChapterInTree(edited.kapitler, chapterId, next);

    // 2) rules (sticky) => returnerar både kapitler + toast-messages
    const ruleRes = applyAllRules(toggled);

    // Ingen ändring => gör inget
    if (ruleRes.kapitler === edited.kapitler) return;

    // 3) skriv tillbaka uppdaterad data
    dispatch(
      setEditedDataInRedux({
        code: 101,
        data: {
          ...edited,
          kapitler: ruleRes.kapitler,
        },
      }),
    );

    // 4) unika meddelanden per regel
    for (const msg of ruleRes.messages) {
      dispatch(setShowSuccessMessageThunk(msg));
    }
  };
